import React, { useEffect, useState } from "react";
import { Plus, Lock, Unlock, Share2, Trash2, Eye } from "lucide-react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { createEventsRequest, fetcheventsRequest } from "../store/slice/events/events.slice";
import { useDispatch, useSelector } from "react-redux";
import Loader from "./Loader";
import { API_URL } from "../utils/enum";
import EventForm from "../Forms/CreateEvent";


const FolderManager = ({ setFolders }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [newFolderName, setNewFolderName] = useState("");
  const [newFolderSecure, setNewFolderSecure] = useState(false);
  const { events, loading, error,success, successMessage } = useSelector((state) => state.events);

  useEffect(() => {
    if (!loading && !error) {
      dispatch(fetcheventsRequest());
    }
  }, []);

  const createFolder = async (formData) => {
      try {
        dispatch(createEventsRequest(formData));

        // //setFolders((prev) => [...prev, newFolder]);
        setNewFolderName("");
        setNewFolderSecure(false);
        setShowCreateModal(false);
      } catch (err) {
        console.error("Failed to create event:", err);
      }
  };

  const toggleSecurity = (id) => {
    setFolders((prev) =>
      prev.map((event) =>
        event.id === id ? { ...event, isSecure: !event.isSecure } : event
      )
    );
  };

  const deleteFolder = (id) => {
    if (
      window.confirm(
        "Are you sure you want to delete this event? This action cannot be undone."
      )
    ) {
      setFolders((prev) => prev.filter((event) => event.id !== id));
    }
  };

  const copyShareLink = (link) => {
    navigator.clipboard.writeText(link);
    // You could show a toast notification here
  };

  return (
    <>
      {loading ? (
        <div className="flex items-center justify-center h-screen">
          <Loader size="large" fullscreen={true} />
        </div>
      ) : (
        <div className="space-y-6">
          {/* Header */}
          <div className="flex justify-between items-center">
            <h3 className="text-lg font-medium text-gray-900">Photo Folders</h3>
            <button
              onClick={() => setShowCreateModal(true)}
              className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
              <Plus className="h-5 w-5 mr-2" />
              Create Folder
            </button>
          </div>
 {success && successMessage && <div class="bg-teal-100 border-t-4 border-teal-500 rounded-b text-teal-900 px-4 py-3 shadow-md" role="alert">
  <div class="flex">
    <div class="py-1"><svg class="fill-current h-6 w-6 text-teal-500 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"/></svg></div>
    <div>
      <p class="font-bold">Created Successfully</p>
      <p class="text-sm">{successMessage}</p>
    </div>
  </div>
</div>}
          {/* Folders Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {events?.map((event) => (
              <div
                key={event.name}
                onClick={() => navigate(`/events/${event.id}/photos`)}
                className="bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-md transition-shadow">
                {/* Thumbnail */}
                <div className="aspect-video bg-gray-100 relative overflow-hidden">
                 {event.thumbnailUrl && <img
                    src={event.thumbnailUrl}
                    alt={event.name}
                    className="w-full h-full object-cover"
                  />}
                  <div className="absolute top-3 right-3">
                    {event.isSecure ? (
                      <div className="bg-red-500 text-white p-2 rounded-full">
                        <Lock className="h-4 w-4" />
                      </div>
                    ) : (
                      <div className="bg-emerald-500 text-white p-2 rounded-full">
                        <Unlock className="h-4 w-4" />
                      </div>
                    )}
                  </div>
                </div>

                {/* Content */}
                <div className="p-4">
                  <h4 className="text-lg font-medium text-gray-900 mb-2">
                    {event.name}
                  </h4>
                  <p className="text-sm text-gray-500 mb-4">
                    {event.totalPhotos} photos • Created {event.createdAt && (() => { const d = new Date(event.createdAt); return `${d.getDate().toString().padStart(2, '0')}-${(d.getMonth()+1).toString().padStart(2, '0')}-${d.getFullYear().toString().slice(-2)}`; })()} • Category: {event.category} 
                  </p>

                  {/* Actions */}
                  <div className="flex items-center justify-between">
                    <div className="flex space-x-2">
                      <button
                        onClick={() => toggleSecurity(event.id)}
                        className={`p-2 rounded-lg transition-colors ${
                          event.isSecure
                            ? "bg-red-100 text-red-600 hover:bg-red-200"
                            : "bg-emerald-100 text-emerald-600 hover:bg-emerald-200"
                        }`}
                        title={event.isSecure ? "Make Public" : "Make Secure"}>
                        {event.isSecure ? (
                          <Lock className="h-4 w-4" />
                        ) : (
                          <Unlock className="h-4 w-4" />
                        )}
                      </button>

                      <button
                        onClick={() => copyShareLink(event.shareLink)}
                        className="p-2 bg-blue-100 text-blue-600 rounded-lg hover:bg-blue-200 transition-colors"
                        title="Copy Share Link">
                        <Share2 className="h-4 w-4" />
                      </button>

                      <button
                        className="p-2 bg-gray-100 text-gray-600 rounded-lg hover:bg-gray-200 transition-colors"
                        title="View Folder">
                        <Eye className="h-4 w-4" />
                      </button>
                    </div>

                    <button
                      onClick={() => deleteFolder(event.id)}
                      className="p-2 bg-red-100 text-red-600 rounded-lg hover:bg-red-200 transition-colors"
                      title="Delete Folder">
                      <Trash2 className="h-4 w-4" />
                    </button>
                  </div>

                  {/* Share Link */}
                  <div className="mt-4 p-3 bg-gray-50 rounded-lg">
                    <p className="text-xs text-gray-500 mb-1">Share Link</p>
                    <p className="text-sm text-gray-700 font-mono truncate">
                      {event.shareLink}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Create Folder Modal */}
       {showCreateModal && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
    <div className="bg-white rounded-2xl p-6 w-full max-w-3xl mx-4 shadow-2xl">
      <h3 className="text-xl font-bold text-gray-900 mb-4">
        Create New Event
      </h3>
        <EventForm createFolder={createFolder}/>
    </div>
  </div>
)}
        </div>
      )}
    </>
  );
};

export default FolderManager;
